import React, { useState, useCallback, useEffect, useRef } from "react";
import { T } from '@/styles/tokens';

// ═══════════════════════════════════════════════════════════════
// TRUEPRICE ONBOARDING V3.1 — POST-AUDIT POLISH
// Clustered thumb-zone nav. Velvet momentum pickers. Zip→State.
// ═══════════════════════════════════════════════════════════════

const C = {
  bg: T.cream,
  bgPure: T.white,
  card: "rgba(255,255,255,0.72)",
  cardSolid: T.white,
  glass: "rgba(255,255,255,0.55)",
  glassBorder: "rgba(255,255,255,0.8)",
  glassStrong: "rgba(255,255,255,0.82)",
  ink: T.text,
  inkMed: T.text,
  inkSoft: T.textSecondary,
  inkFaint: T.textMuted,
  inkGhost: T.textMuted,
  border: T.border,
  borderLight: T.borderLight,
  teal: T.primary,
  tealDark: T.primaryDark,
  tealGlow: T.primaryGlow,
  tealSubtle: T.primarySubtle,
  tealGlass: "rgba(61,171,165,0.08)",
  orange: T.warning,
  shadow: "0 2px 16px rgba(26,26,26,0.06)",
  shadowUp: "0 -1px 20px rgba(26,26,26,0.05)",
} as Record<string, string>;

const font = T.fontFamily;

// ─── ZIP → STATE LOOKUP (first 3 digits) ────────────────────
const ZIP_TO_STATE: Record<string, string> = {
  "005":"NY","006":"PR","007":"PR","008":"PR","009":"PR","010":"MA","011":"MA","012":"MA","013":"MA","014":"MA","015":"MA","016":"MA","017":"MA","018":"MA","019":"MA","020":"MA","021":"MA","022":"MA","023":"MA","024":"MA","025":"MA","026":"MA","027":"MA","028":"RI","029":"RI",
  "030":"NH","031":"NH","032":"NH","033":"NH","034":"NH","035":"NH","036":"NH","037":"NH","038":"NH","039":"ME","040":"ME","041":"ME","042":"ME","043":"ME","044":"ME","045":"ME","046":"ME","047":"ME","048":"ME","049":"ME",
  "050":"VT","051":"VT","052":"VT","053":"VT","054":"VT","055":"VT","056":"VT","057":"VT","058":"VT","059":"VT",
  "060":"CT","061":"CT","062":"CT","063":"CT","064":"CT","065":"CT","066":"CT","067":"CT","068":"CT","069":"CT",
  "070":"NJ","071":"NJ","072":"NJ","073":"NJ","074":"NJ","075":"NJ","076":"NJ","077":"NJ","078":"NJ","079":"NJ","080":"NJ","081":"NJ","082":"NJ","083":"NJ","084":"NJ","085":"NJ","086":"NJ","087":"NJ","088":"NJ","089":"NJ",
  "090":"AE","091":"AE","092":"AE","093":"AE","094":"AE","095":"AE","096":"AE","097":"AE","098":"AE","099":"AE",
  "100":"NY","101":"NY","102":"NY","103":"NY","104":"NY","105":"NY","106":"NY","107":"NY","108":"NY","109":"NY","110":"NY","111":"NY","112":"NY","113":"NY","114":"NY","115":"NY","116":"NY","117":"NY","118":"NY","119":"NY","120":"NY","121":"NY","122":"NY","123":"NY","124":"NY","125":"NY","126":"NY","127":"NY","128":"NY","129":"NY","130":"NY","131":"NY","132":"NY","133":"NY","134":"NY","135":"NY","136":"NY","137":"NY","138":"NY","139":"NY","140":"NY","141":"NY","142":"NY","143":"NY","144":"NY","145":"NY","146":"NY","147":"NY","148":"NY","149":"NY",
  "150":"PA","151":"PA","152":"PA","153":"PA","154":"PA","155":"PA","156":"PA","157":"PA","158":"PA","159":"PA","160":"PA","161":"PA","162":"PA","163":"PA","164":"PA","165":"PA","166":"PA","167":"PA","168":"PA","169":"PA","170":"PA","171":"PA","172":"PA","173":"PA","174":"PA","175":"PA","176":"PA","177":"PA","178":"PA","179":"PA","180":"PA","181":"PA","182":"PA","183":"PA","184":"PA","185":"PA","186":"PA","187":"PA","188":"PA","189":"PA","190":"PA","191":"PA","192":"PA","193":"PA","194":"PA","195":"PA","196":"PA",
  "197":"DE","198":"DE","199":"DE",
  "200":"DC","201":"VA","202":"DC","203":"DC","204":"DC","205":"DC","206":"MD","207":"MD","208":"MD","209":"MD","210":"MD","211":"MD","212":"MD","214":"MD","215":"MD","216":"MD","217":"MD","218":"MD","219":"MD",
  "220":"VA","221":"VA","222":"VA","223":"VA","224":"VA","225":"VA","226":"VA","227":"VA","228":"VA","229":"VA","230":"VA","231":"VA","232":"VA","233":"VA","234":"VA","235":"VA","236":"VA","237":"VA","238":"VA","239":"VA","240":"VA","241":"VA","242":"VA","243":"VA","244":"VA","245":"VA","246":"WV","247":"WV","248":"WV","249":"WV","250":"WV","251":"WV","252":"WV","253":"WV","254":"WV","255":"WV","256":"WV","257":"WV","258":"WV","259":"WV","260":"WV","261":"WV","262":"WV","263":"WV","264":"WV","265":"WV","266":"WV","267":"WV","268":"WV",
  "270":"NC","271":"NC","272":"NC","273":"NC","274":"NC","275":"NC","276":"NC","277":"NC","278":"NC","279":"NC","280":"NC","281":"NC","282":"NC","283":"NC","284":"NC","285":"NC","286":"NC","287":"NC","288":"NC","289":"NC",
  "290":"SC","291":"SC","292":"SC","293":"SC","294":"SC","295":"SC","296":"SC","297":"SC","298":"SC","299":"SC",
  "300":"GA","301":"GA","302":"GA","303":"GA","304":"GA","305":"GA","306":"GA","307":"GA","308":"GA","309":"GA","310":"GA","311":"GA","312":"GA","313":"GA","314":"GA","315":"GA","316":"GA","317":"GA","318":"GA","319":"GA",
  "320":"FL","321":"FL","322":"FL","323":"FL","324":"FL","325":"FL","326":"FL","327":"FL","328":"FL","329":"FL","330":"FL","331":"FL","332":"FL","333":"FL","334":"FL","335":"FL","336":"FL","337":"FL","338":"FL","339":"FL",
  "340":"AA","341":"FL","342":"FL","344":"FL","346":"FL","347":"FL","349":"FL",
  "350":"AL","351":"AL","352":"AL","353":"AL","354":"AL","355":"AL","356":"AL","357":"AL","358":"AL","359":"AL","360":"AL","361":"AL","362":"AL","363":"AL","364":"AL","365":"AL","366":"AL","367":"AL","368":"AL","369":"AL",
  "370":"TN","371":"TN","372":"TN","373":"TN","374":"TN","375":"TN","376":"TN","377":"TN","378":"TN","379":"TN","380":"TN","381":"TN","382":"TN","383":"TN","384":"TN","385":"TN",
  "386":"MS","387":"MS","388":"MS","389":"MS","390":"MS","391":"MS","392":"MS","393":"MS","394":"MS","395":"MS","396":"MS","397":"MS",
  "400":"KY","401":"KY","402":"KY","403":"KY","404":"KY","405":"KY","406":"KY","407":"KY","408":"KY","409":"KY","410":"KY","411":"KY","412":"KY","413":"KY","414":"KY","415":"KY","416":"KY","417":"KY","418":"KY",
  "420":"KY","421":"KY","422":"KY","423":"KY","424":"KY","425":"KY","426":"KY","427":"KY",
  "430":"OH","431":"OH","432":"OH","433":"OH","434":"OH","435":"OH","436":"OH","437":"OH","438":"OH","439":"OH","440":"OH","441":"OH","442":"OH","443":"OH","444":"OH","445":"OH","446":"OH","447":"OH","448":"OH","449":"OH","450":"OH","451":"OH","452":"OH","453":"OH","454":"OH","455":"OH","456":"OH","457":"OH","458":"OH","459":"OH",
  "460":"IN","461":"IN","462":"IN","463":"IN","464":"IN","465":"IN","466":"IN","467":"IN","468":"IN","469":"IN","470":"IN","471":"IN","472":"IN","473":"IN","474":"IN","475":"IN","476":"IN","477":"IN","478":"IN","479":"IN",
  "480":"MI","481":"MI","482":"MI","483":"MI","484":"MI","485":"MI","486":"MI","487":"MI","488":"MI","489":"MI","490":"MI","491":"MI","492":"MI","493":"MI","494":"MI","495":"MI","496":"MI","497":"MI","498":"MI","499":"MI",
  "500":"IA","501":"IA","502":"IA","503":"IA","504":"IA","505":"IA","506":"IA","507":"IA","508":"IA","509":"IA","510":"IA","511":"IA","512":"IA","513":"IA","514":"IA","515":"IA","516":"IA","520":"IA","521":"IA","522":"IA","523":"IA","524":"IA","525":"IA","526":"IA","527":"IA","528":"IA",
  "530":"WI","531":"WI","532":"WI","534":"WI","535":"WI","537":"WI","538":"WI","539":"WI","540":"WI","541":"WI","542":"WI","543":"WI","544":"WI","545":"WI","546":"WI","547":"WI","548":"WI","549":"WI",
  "550":"MN","551":"MN","553":"MN","554":"MN","555":"MN","556":"MN","557":"MN","558":"MN","559":"MN","560":"MN","561":"MN","562":"MN","563":"MN","564":"MN","565":"MN","566":"MN","567":"MN",
  "570":"SD","571":"SD","572":"SD","573":"SD","574":"SD","575":"SD","576":"SD","577":"SD",
  "580":"ND","581":"ND","582":"ND","583":"ND","584":"ND","585":"ND","586":"ND","587":"ND","588":"ND",
  "590":"MT","591":"MT","592":"MT","593":"MT","594":"MT","595":"MT","596":"MT","597":"MT","598":"MT","599":"MT",
  "600":"IL","601":"IL","602":"IL","603":"IL","604":"IL","605":"IL","606":"IL","607":"IL","608":"IL","609":"IL","610":"IL","611":"IL","612":"IL","613":"IL","614":"IL","615":"IL","616":"IL","617":"IL","618":"IL","619":"IL","620":"IL","621":"IL","622":"IL","623":"IL","624":"IL","625":"IL","626":"IL","627":"IL","628":"IL","629":"IL",
  "630":"MO","631":"MO","633":"MO","634":"MO","635":"MO","636":"MO","637":"MO","638":"MO","639":"MO","640":"MO","641":"MO","644":"MO","645":"MO","646":"MO","647":"MO","648":"MO","649":"MO","650":"MO","651":"MO","652":"MO","653":"MO","654":"MO","655":"MO","656":"MO","657":"MO","658":"MO","659":"MO",
  "660":"KS","661":"KS","662":"KS","664":"KS","665":"KS","666":"KS","667":"KS","668":"KS","669":"KS","670":"KS","671":"KS","672":"KS","673":"KS","674":"KS","675":"KS","676":"KS","677":"KS","678":"KS","679":"KS",
  "680":"NE","681":"NE","683":"NE","684":"NE","685":"NE","686":"NE","687":"NE","688":"NE","689":"NE","690":"NE","691":"NE","692":"NE","693":"NE",
  "700":"LA","701":"LA","703":"LA","704":"LA","705":"LA","706":"LA","707":"LA","708":"LA","710":"LA","711":"LA","712":"LA","713":"LA","714":"LA",
  "716":"AR","717":"AR","718":"AR","719":"AR","720":"AR","721":"AR","722":"AR","723":"AR","724":"AR","725":"AR","726":"AR","727":"AR","728":"AR","729":"AR",
  "730":"OK","731":"OK","734":"OK","735":"OK","736":"OK","737":"OK","738":"OK","739":"OK","740":"OK","741":"OK","743":"OK","744":"OK","745":"OK","746":"OK","747":"OK","748":"OK","749":"OK",
  "750":"TX","751":"TX","752":"TX","753":"TX","754":"TX","755":"TX","756":"TX","757":"TX","758":"TX","759":"TX","760":"TX","761":"TX","762":"TX","763":"TX","764":"TX","765":"TX","766":"TX","767":"TX","768":"TX","769":"TX","770":"TX","771":"TX","772":"TX","773":"TX","774":"TX","775":"TX","776":"TX","777":"TX","778":"TX","779":"TX","780":"TX","781":"TX","782":"TX","783":"TX","784":"TX","785":"TX","786":"TX","787":"TX","788":"TX","789":"TX","790":"TX","791":"TX","792":"TX","793":"TX","794":"TX","795":"TX","796":"TX","797":"TX","798":"TX","799":"TX",
  "800":"CO","801":"CO","802":"CO","803":"CO","804":"CO","805":"CO","806":"CO","807":"CO","808":"CO","809":"CO","810":"CO","811":"CO","812":"CO","813":"CO","814":"CO","815":"CO","816":"CO",
  "820":"WY","821":"WY","822":"WY","823":"WY","824":"WY","825":"WY","826":"WY","827":"WY","828":"WY","829":"WY","830":"WY","831":"WY",
  "832":"ID","833":"ID","834":"ID","835":"ID","836":"ID","837":"ID","838":"ID",
  "840":"UT","841":"UT","842":"UT","843":"UT","844":"UT","845":"UT","846":"UT","847":"UT",
  "850":"AZ","851":"AZ","852":"AZ","853":"AZ","855":"AZ","856":"AZ","857":"AZ","859":"AZ","860":"AZ","863":"AZ","864":"AZ","865":"AZ",
  "870":"NM","871":"NM","872":"NM","873":"NM","874":"NM","875":"NM","876":"NM","877":"NM","878":"NM","879":"NM","880":"NM","881":"NM","882":"NM","883":"NM","884":"NM",
  "889":"NV","890":"NV","891":"NV","893":"NV","894":"NV","895":"NV","896":"NV","897":"NV","898":"NV",
  "900":"CA","901":"CA","902":"CA","903":"CA","904":"CA","905":"CA","906":"CA","907":"CA","908":"CA","910":"CA","911":"CA","912":"CA","913":"CA","914":"CA","915":"CA","916":"CA","917":"CA","918":"CA","919":"CA","920":"CA","921":"CA","922":"CA","923":"CA","924":"CA","925":"CA","926":"CA","927":"CA","928":"CA","930":"CA","931":"CA","932":"CA","933":"CA","934":"CA","935":"CA","936":"CA","937":"CA","938":"CA","939":"CA","940":"CA","941":"CA","942":"CA","943":"CA","944":"CA","945":"CA","946":"CA","947":"CA","948":"CA","949":"CA","950":"CA","951":"CA","952":"CA","953":"CA","954":"CA","955":"CA","956":"CA","957":"CA","958":"CA","959":"CA","960":"CA","961":"CA",
  "967":"HI","968":"HI",
  "970":"OR","971":"OR","972":"OR","973":"OR","974":"OR","975":"OR","976":"OR","977":"OR","978":"OR","979":"OR",
  "980":"WA","981":"WA","982":"WA","983":"WA","984":"WA","985":"WA","986":"WA","988":"WA","989":"WA","990":"WA","991":"WA","992":"WA","993":"WA","994":"WA",
  "995":"AK","996":"AK","997":"AK","998":"AK","999":"AK",
};

function lookupState(zip: string): string {
  if (!zip || zip.length < 3) return "";
  const prefix = zip.slice(0, 3);
  return ZIP_TO_STATE[prefix] || "";
}

// ─── TINY ICONS (inline SVG) ──────────────────────────────────
const Icons = {
  palette: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><circle cx="10" cy="8" r="1.2" fill={c} stroke="none"/><circle cx="14.5" cy="8" r="1.2" fill={c} stroke="none"/><circle cx="8" cy="12" r="1.2" fill={c} stroke="none"/><circle cx="15" cy="12.5" r="1.2" fill={c} stroke="none"/>
    </svg>
  ),
  spark: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
    </svg>
  ),
  briefcase: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
    </svg>
  ),
  trophy: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H3a1 1 0 01-1-1V5a1 1 0 011-1h3M18 9h3a1 1 0 001-1V5a1 1 0 00-1-1h-3M6 4h12v6a6 6 0 11-12 0V4z"/><path d="M12 16v3M8 22h8"/>
    </svg>
  ),
  dollar: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
    </svg>
  ),
  clock: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  mapPin: (c = C.inkFaint) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  check: (c = C.teal) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  chevLeft: (c = C.inkSoft) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  arrowRight: (c = "#fff") => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
};

// ─── ILLUSTRATIONS (monochrome teal line art) ────────────────
function Illo({ type }: { type: string }) {
  const s: React.CSSProperties = { width: "100%", height: "100%", maxHeight: 200 };
  const lc = C.teal;
  const la = 0.6;
  const lb = 0.2;

  const illos: Record<string, React.ReactNode> = {
    welcome: (
      <svg viewBox="0 0 240 200" fill="none" style={s}>
        <g opacity={la}>
          <line x1="88" y1="50" x2="75" y2="175" stroke={lc} strokeWidth="2.2" strokeLinecap="round"/>
          <line x1="152" y1="50" x2="165" y2="175" stroke={lc} strokeWidth="2.2" strokeLinecap="round"/>
          <line x1="120" y1="42" x2="120" y2="120" stroke={lc} strokeWidth="2.2" strokeLinecap="round"/>
          <rect x="82" y="48" width="76" height="58" rx="3" stroke={lc} strokeWidth="2" fill={C.tealSubtle}/>
          <path d="M92 72 Q108 62 124 72 Q140 82 148 70" stroke={lc} strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.7"/>
          <path d="M95 82 Q110 78 130 85" stroke={lc} strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.4"/>
        </g>
        <g opacity={la} transform="translate(155, 55)">
          <rect width="38" height="22" rx="4" stroke={lc} strokeWidth="1.8" fill="rgba(61,171,165,0.05)"/>
          <text x="19" y="15" textAnchor="middle" fontSize="11" fontWeight="700" fill={lc} fontFamily={font}>$</text>
          <circle cx="7" cy="11" r="2.5" stroke={lc} strokeWidth="1.2" fill="none"/>
        </g>
        <circle cx="60" cy="65" r="2" fill={lc} opacity={lb}/>
        <circle cx="185" cy="90" r="1.5" fill={lc} opacity={lb}/>
        <circle cx="50" cy="130" r="1.8" fill={lc} opacity="0.15"/>
      </svg>
    ),
    career: (
      <svg viewBox="0 0 240 200" fill="none" style={s}>
        <g opacity={la}>
          {[0,1,2,3].map(i => (
            <g key={i}>
              <rect x={60 + i * 36} y={145 - (i+1) * 28} width="24" height={(i+1) * 28} rx="5"
                stroke={lc} strokeWidth="1.8" fill={i === 3 ? C.tealSubtle : "none"}/>
              {i === 3 && <circle cx={72 + i * 36} cy={145 - (i+1) * 28 - 10} r="3" fill={lc} opacity="0.4"/>}
            </g>
          ))}
          <line x1="50" y1="148" x2="200" y2="148" stroke={lc} strokeWidth="1.2" opacity="0.3"/>
        </g>
        <g opacity={lb} transform="translate(165, 42) rotate(30)">
          <rect width="6" height="45" rx="2" fill={lc}/><rect y="-8" x="-2" width="10" height="10" rx="2" fill={lc} opacity="0.5"/>
        </g>
      </svg>
    ),
    burn: (
      <svg viewBox="0 0 240 200" fill="none" style={s}>
        <g opacity={la}>
          {[0,1,2].map(i => (
            <g key={i} transform={`translate(${85 + i * 8}, ${75 + i * 30})`}>
              <ellipse cx="35" cy="18" rx="35" ry="14" fill={C.tealSubtle} stroke={lc} strokeWidth="1.8"/>
              <ellipse cx="35" cy="12" rx="35" ry="14" fill={C.bg} stroke={lc} strokeWidth="1.8"/>
              <text x="35" y="17" textAnchor="middle" fontSize="13" fontWeight="700" fill={lc} opacity="0.5" fontFamily={font}>$</text>
            </g>
          ))}
        </g>
        <circle cx="55" cy="60" r="2" fill={lc} opacity={lb}/>
        <circle cx="190" cy="155" r="2.5" fill={lc} opacity="0.15"/>
      </svg>
    ),
    hours: (
      <svg viewBox="0 0 240 200" fill="none" style={s}>
        <g opacity={la}>
          <circle cx="120" cy="100" r="55" stroke={lc} strokeWidth="2" fill={C.tealSubtle}/>
          <circle cx="120" cy="100" r="50" stroke={lc} strokeWidth="1.5" fill={C.bg}/>
          {[0,1,2,3,4,5,6,7,8,9,10,11].map(i => {
            const a = (i * 30 - 90) * Math.PI / 180;
            return <line key={i} x1={120 + Math.cos(a) * 44} y1={100 + Math.sin(a) * 44} x2={120 + Math.cos(a) * 48} y2={100 + Math.sin(a) * 48}
              stroke={lc} strokeWidth={i % 3 === 0 ? "2.2" : "1.2"} strokeLinecap="round" opacity="0.4"/>;
          })}
          <line x1="120" y1="100" x2="120" y2="62" stroke={lc} strokeWidth="2.5" strokeLinecap="round"/>
          <line x1="120" y1="100" x2="152" y2="108" stroke={lc} strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
          <circle cx="120" cy="100" r="4" fill={lc} opacity="0.3"/>
        </g>
        <g opacity={lb}><circle cx="58" cy="45" r="4" fill={lc}/><ellipse cx="58" cy="55" rx="2" ry="6" fill={lc}/></g>
      </svg>
    ),
    location: (
      <svg viewBox="0 0 240 200" fill="none" style={s}>
        <g opacity={la}>
          <path d="M120 40 C95 40 75 60 75 85 C75 120 120 165 120 165 C120 165 165 120 165 85 C165 60 145 40 120 40Z"
            stroke={lc} strokeWidth="2" fill={C.tealSubtle}/>
          <circle cx="120" cy="82" r="18" stroke={lc} strokeWidth="1.8" fill={C.bg}/>
          <circle cx="120" cy="82" r="6" fill={lc} opacity="0.25"/>
        </g>
        <line x1="40" y1="168" x2="200" y2="168" stroke={lc} strokeWidth="1.2" opacity="0.15"/>
      </svg>
    ),
    complete: (
      <svg viewBox="0 0 240 200" fill="none" style={s}>
        <g opacity={la}>
          <circle cx="120" cy="100" r="58" stroke={lc} strokeWidth="2" fill={C.tealSubtle}/>
          <circle cx="120" cy="100" r="50" stroke={lc} strokeWidth="1.5" fill={C.bg}/>
          <polyline points="96 100 112 116 144 84" stroke={lc} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </g>
        <g opacity="0.15">
          {[0,1,2,3,4,5].map(i => {
            const a = (i * 60) * Math.PI / 180;
            return <line key={i} x1={120 + Math.cos(a) * 64} y1={100 + Math.sin(a) * 64} x2={120 + Math.cos(a) * 72} y2={100 + Math.sin(a) * 72}
              stroke={lc} strokeWidth="2" strokeLinecap="round"/>;
          })}
        </g>
      </svg>
    ),
  };
  return <>{illos[type] || null}</>;
}

// ─── PROGRESS DOTS ───────────────────────────────────────────
function ProgressDots({ current, total = 6 }: { current: number; total?: number }) {
  return (
    <div style={{
      display: "flex", gap: 6, justifyContent: "center",
      padding: "14px 0 2px",
    }}>
      {Array.from({ length: total }, (_, i) => (
        <div key={i} style={{
          width: i === current ? 22 : 7,
          height: 7,
          borderRadius: 4,
          background: i < current ? C.teal : i === current ? C.teal : C.border,
          opacity: i < current ? 0.4 : 1,
          transition: "all 350ms cubic-bezier(0.32, 0.72, 0, 1)",
        }}/>
      ))}
    </div>
  );
}

// ─── SELECTION ROW (icon | text | checkmark) ─────────────────
function SelectionRow({ icon, label, desc, selected, onSelect, isLast }: {
  icon: (c: string) => React.ReactNode;
  label: string;
  desc: string;
  selected: boolean;
  onSelect: () => void;
  isLast: boolean;
}) {
  return (
    <button onClick={onSelect} style={{
      width: "100%", display: "flex", alignItems: "center", gap: 14,
      padding: "15px 16px",
      background: selected ? C.glassStrong : "transparent",
      border: "none",
      borderBottom: isLast ? "none" : `1px solid ${C.borderLight}`,
      borderRadius: selected ? 14 : 0,
      cursor: "pointer",
      transition: "all 200ms ease",
      outline: "none",
      position: "relative",
      ...(selected ? {
        boxShadow: `0 2px 12px ${C.tealGlow}, inset 0 0 0 1.5px ${C.teal}20`,
        margin: "0 -2px",
        padding: "15px 18px",
        borderBottom: "none",
      } : {}),
    }}>
      <div style={{
        width: 36, height: 36, borderRadius: 10,
        background: selected ? C.tealSubtle : C.borderLight,
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0,
        transition: "all 200ms ease",
      }}>
        {icon(selected ? C.teal : C.inkFaint)}
      </div>
      <div style={{ flex: 1, textAlign: "left" }}>
        <div style={{
          fontSize: 15, fontWeight: 600,
          color: selected ? C.ink : C.inkMed,
          letterSpacing: "-0.01em", fontFamily: font,
        }}>{label}</div>
        <div style={{
          fontSize: 12, color: C.inkSoft,
          lineHeight: 1.3, marginTop: 1, fontFamily: font,
        }}>{desc}</div>
      </div>
      {selected && (
        <div style={{
          width: 26, height: 26, borderRadius: 13,
          background: C.teal,
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
        }}>
          {Icons.check("#fff")}
        </div>
      )}
    </button>
  );
}

// ─── VELVET SCROLL PICKER (momentum physics) ─────────────────
function ScrollPicker({ value, onChange, min, max, step = 1, format, suffix = "", visible = 5 }: {
  value: number;
  onChange: (v: number) => void;
  min: number;
  max: number;
  step?: number;
  format?: (v: number) => string;
  suffix?: string;
  visible?: number;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const itemH = 48;
  const items: number[] = [];
  for (let v = min; v <= max; v += step) items.push(v);
  const idx = items.indexOf(value);
  const pad = Math.floor(visible / 2);

  // Physics state
  const physics = useRef({
    dragging: false,
    lastY: 0,
    lastTime: 0,
    velocity: 0,
    velocitySamples: [] as Array<{ v: number; t: number }>,
    animFrame: null as number | null,
    settled: true,
  });

  // Initial scroll position
  useEffect(() => {
    if (scrollRef.current && physics.current.settled) {
      scrollRef.current.scrollTop = idx * itemH;
    }
  }, [idx]);

  // Snap to nearest after scroll stops
  const snapToNearest = useCallback(() => {
    if (!scrollRef.current) return;
    const scrollIdx = Math.round(scrollRef.current.scrollTop / itemH);
    const clamped = Math.max(0, Math.min(items.length - 1, scrollIdx));
    const targetScroll = clamped * itemH;

    // Smooth spring-snap
    const startScroll = scrollRef.current.scrollTop;
    const distance = targetScroll - startScroll;
    if (Math.abs(distance) < 0.5) {
      scrollRef.current.scrollTop = targetScroll;
      if (items[clamped] !== value) onChange(items[clamped]);
      physics.current.settled = true;
      return;
    }

    const duration = 280;
    const startTime = performance.now();
    const el = scrollRef.current;

    const animate = (now: number) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      // Critically-damped spring curve
      const ease = 1 - Math.pow(1 - t, 3) * (1 + 3 * t);
      el.scrollTop = startScroll + distance * ease;

      if (t < 1) {
        physics.current.animFrame = requestAnimationFrame(animate);
      } else {
        el.scrollTop = targetScroll;
        if (items[clamped] !== value) onChange(items[clamped]);
        physics.current.settled = true;
      }
    };
    physics.current.animFrame = requestAnimationFrame(animate);
  }, [items, value, onChange]);

  // Deceleration with momentum
  const startMomentum = useCallback((initialVelocity: number) => {
    if (!scrollRef.current) return;
    physics.current.settled = false;

    // Clamp velocity for velvet feel (not too wild)
    let vel = Math.max(-3500, Math.min(3500, initialVelocity));

    // Below threshold: just snap
    if (Math.abs(vel) < 80) {
      snapToNearest();
      return;
    }

    const friction = 0.965; // Higher = more glide. 0.965 feels like quality velvet.
    const minVel = 15;
    const el = scrollRef.current;

    const decelerate = () => {
      if (!el || physics.current.dragging) return;

      vel *= friction;
      el.scrollTop += vel * (1 / 60);

      // Rubber-band at edges
      const maxScroll = (items.length - 1) * itemH;
      const st = el.scrollTop;
      if (st < 0) {
        el.scrollTop = 0;
        vel = 0;
      } else if (st > maxScroll) {
        el.scrollTop = maxScroll;
        vel = 0;
      }

      if (Math.abs(vel) > minVel) {
        physics.current.animFrame = requestAnimationFrame(decelerate);
      } else {
        snapToNearest();
      }
    };

    physics.current.animFrame = requestAnimationFrame(decelerate);
  }, [items, snapToNearest]);

  // Track velocity from touch/mouse samples
  const recordVelocity = useCallback((clientY: number) => {
    const now = performance.now();
    const p = physics.current;
    const dt = now - p.lastTime;
    if (dt > 0) {
      const vy = (p.lastY - clientY) / (dt / 1000); // px per second
      p.velocitySamples.push({ v: vy, t: now });
      // Keep last 5 samples for smoothing
      if (p.velocitySamples.length > 5) p.velocitySamples.shift();
    }
    p.lastY = clientY;
    p.lastTime = now;
  }, []);

  const getSmoothedVelocity = useCallback(() => {
    const samples = physics.current.velocitySamples;
    if (samples.length === 0) return 0;
    const now = performance.now();
    // Weight recent samples more
    let totalWeight = 0;
    let weightedSum = 0;
    samples.forEach(s => {
      const age = now - s.t;
      const weight = Math.max(0, 1 - age / 200); // Decay over 200ms
      weightedSum += s.v * weight;
      totalWeight += weight;
    });
    return totalWeight > 0 ? weightedSum / totalWeight : 0;
  }, []);

  // Touch handlers
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    const p = physics.current;
    if (p.animFrame) cancelAnimationFrame(p.animFrame);
    p.dragging = true;
    p.settled = false;
    p.lastY = e.touches[0].clientY;
    p.lastTime = performance.now();
    p.velocitySamples = [];
    p.velocity = 0;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    if (!physics.current.dragging || !scrollRef.current) return;
    const clientY = e.touches[0].clientY;
    const delta = physics.current.lastY - clientY;
    scrollRef.current.scrollTop += delta;
    recordVelocity(clientY);
  }, [recordVelocity]);

  const handleTouchEnd = useCallback(() => {
    physics.current.dragging = false;
    const vel = getSmoothedVelocity();
    startMomentum(vel);
  }, [getSmoothedVelocity, startMomentum]);

  // Mouse handlers (for desktop preview)
  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    const p = physics.current;
    if (p.animFrame) cancelAnimationFrame(p.animFrame);
    p.dragging = true;
    p.settled = false;
    p.lastY = e.clientY;
    p.lastTime = performance.now();
    p.velocitySamples = [];
    e.preventDefault();
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!physics.current.dragging || !scrollRef.current) return;
      const delta = physics.current.lastY - e.clientY;
      scrollRef.current.scrollTop += delta;
      recordVelocity(e.clientY);
    };
    const handleMouseUp = () => {
      if (!physics.current.dragging) return;
      physics.current.dragging = false;
      startMomentum(getSmoothedVelocity());
    };
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [recordVelocity, startMomentum, getSmoothedVelocity]);

  // Click to select
  const handleItemClick = useCallback((v: number, i: number) => {
    if (!scrollRef.current) return;
    const p = physics.current;
    if (p.animFrame) cancelAnimationFrame(p.animFrame);
    p.settled = false;

    const targetScroll = i * itemH;
    const startScroll = scrollRef.current.scrollTop;
    const distance = targetScroll - startScroll;
    const duration = 350;
    const startTime = performance.now();
    const el = scrollRef.current;

    const animate = (now: number) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const ease = 1 - Math.pow(1 - t, 4); // Quartic ease-out — silky
      el.scrollTop = startScroll + distance * ease;
      if (t < 1) {
        physics.current.animFrame = requestAnimationFrame(animate);
      } else {
        el.scrollTop = targetScroll;
        onChange(v);
        physics.current.settled = true;
      }
    };
    physics.current.animFrame = requestAnimationFrame(animate);
  }, [onChange]);

  // Cleanup
  useEffect(() => {
    return () => {
      if (physics.current.animFrame) cancelAnimationFrame(physics.current.animFrame);
    };
  }, []);

  return (
    <div style={{
      position: "relative",
      height: itemH * visible,
      overflow: "hidden",
      borderRadius: 16,
      background: C.card,
      border: `1px solid ${C.borderLight}`,
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
    }}>
      {/* Selection highlight — contained pill */}
      <div style={{
        position: "absolute",
        top: itemH * pad + 4,
        left: 16, right: 16,
        height: itemH - 8,
        borderRadius: 12,
        background: C.tealSubtle,
        border: `1.5px solid rgba(61,171,165,0.12)`,
        pointerEvents: "none",
        zIndex: 1,
      }}/>
      {/* Top fade mask */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0,
        height: itemH * 1.8,
        background: `linear-gradient(rgba(250,248,243,0.95), rgba(250,248,243,0.6), transparent)`,
        pointerEvents: "none", zIndex: 2,
        borderRadius: "16px 16px 0 0",
      }}/>
      {/* Bottom fade mask */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0,
        height: itemH * 1.8,
        background: `linear-gradient(transparent, rgba(250,248,243,0.6), rgba(250,248,243,0.95))`,
        pointerEvents: "none", zIndex: 2,
        borderRadius: "0 0 16px 16px",
      }}/>
      {/* Scroll area — touch-driven, no native scroll behavior */}
      <div
        ref={scrollRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        style={{
          height: "100%",
          overflowY: "scroll",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          touchAction: "none",
          userSelect: "none",
          WebkitUserSelect: "none",
          cursor: "grab",
        } as React.CSSProperties}
      >
        {/* Top padding */}
        <div style={{ height: itemH * pad }}/>
        {items.map((v, i) => {
          const dist = Math.abs(i - idx);
          const scale = dist === 0 ? 1 : dist === 1 ? 0.88 : 0.78;
          return (
            <div key={v}
              onClick={() => handleItemClick(v, i)}
              style={{
                height: itemH,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: dist === 0 ? 24 : dist === 1 ? 18 : 16,
                fontWeight: dist === 0 ? 700 : dist === 1 ? 500 : 400,
                color: dist === 0 ? C.teal : dist === 1 ? C.inkSoft : C.inkGhost,
                fontFamily: font,
                letterSpacing: "-0.02em",
                transform: `scale(${scale})`,
                opacity: dist === 0 ? 1 : dist === 1 ? 0.7 : 0.35,
                transition: "color 120ms ease, font-weight 120ms ease, transform 200ms cubic-bezier(0.32,0.72,0,1), opacity 200ms ease",
                cursor: "pointer",
                pointerEvents: dist <= 2 ? "auto" : "none",
              }}
            >
              {format ? format(v) : v}
              {suffix && <span style={{
                fontSize: dist === 0 ? 15 : 13,
                fontWeight: 500,
                marginLeft: 5,
                color: dist === 0 ? C.inkSoft : C.inkGhost,
              }}>{suffix}</span>}
            </div>
          );
        })}
        {/* Bottom padding */}
        <div style={{ height: itemH * pad }}/>
      </div>
    </div>
  );
}

// ─── BOTTOM ACTION BAR (clustered right, no separator) ───────
function ActionBar({ onBack, onNext, nextLabel = "Next", nextDisabled = false, showBack = true }: {
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  showBack?: boolean;
}) {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "flex-end",
      padding: "12px 20px",
      paddingBottom: "max(16px, env(safe-area-inset-bottom, 16px))",
      gap: 10,
    }}>
      {showBack && (
        <button onClick={onBack} style={{
          width: 48, height: 48, borderRadius: 24,
          background: C.glassStrong,
          border: `1px solid ${C.border}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          transition: "all 150ms ease",
          flexShrink: 0,
        }}>
          {Icons.chevLeft()}
        </button>
      )}
      <button
        onClick={onNext}
        disabled={nextDisabled}
        style={{
          height: 52, paddingLeft: 28, paddingRight: 22,
          borderRadius: 26,
          border: "none",
          background: nextDisabled ? C.border : C.teal,
          color: nextDisabled ? C.inkGhost : "#fff",
          fontSize: 16, fontWeight: 600,
          fontFamily: font,
          letterSpacing: "-0.01em",
          cursor: nextDisabled ? "default" : "pointer",
          display: "flex", alignItems: "center", gap: 8,
          boxShadow: nextDisabled ? "none" : `0 4px 16px ${C.tealGlow}`,
          transition: "all 250ms cubic-bezier(0.32, 0.72, 0, 1)",
        }}
      >
        {nextLabel}
        {Icons.arrowRight(nextDisabled ? C.inkGhost : "#fff")}
      </button>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════
export default function TruePriceOnboarding() {
  const [step, setStep] = useState(0);
  const [career, setCareer] = useState<string | null>(null);
  const [burn, setBurn] = useState(3000);
  const [hours, setHours] = useState(30);
  const [zip, setZip] = useState("");
  const [st, setSt] = useState("");
  const [transitioning, setTransitioning] = useState(false);
  const [slideDir, setSlideDir] = useState(1);

  // Auto-fill state from zip
  const handleZipChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 5);
    setZip(raw);
    if (raw.length >= 3) {
      const state = lookupState(raw);
      if (state) setSt(state);
    } else {
      setSt("");
    }
  }, []);

  const go = useCallback((target: number) => {
    if (transitioning) return;
    setSlideDir(target > step ? 1 : -1);
    setTransitioning(true);
    setTimeout(() => { setStep(target); setTransitioning(false); }, 280);
  }, [step, transitioning]);

  const next = () => go(step + 1);
  const back = () => go(step - 1);

  const valid = () => {
    switch (step) {
      case 0: return true;
      case 1: return career !== null;
      case 2: return burn >= 100;
      case 3: return hours >= 1;
      case 4: return zip.trim().length === 5 && st.trim().length === 2;
      case 5: return true;
      default: return false;
    }
  };

  const ctaText = () => {
    if (step === 0) return "Start";
    if (step === 4) return "Finish";
    if (step === 5) return "Go to dashboard";
    return "Next";
  };

  const illoKeys = ["welcome", "career", "burn", "hours", "location", "complete"];

  const careerOptions = [
    { key: "unlisted", icon: Icons.palette, label: "Unlisted", desc: "Not actively selling yet" },
    { key: "emerging", icon: Icons.spark, label: "Emerging", desc: "Early sales, inconsistent demand" },
    { key: "working", icon: Icons.briefcase, label: "Working", desc: "Regular sales, pricing pressure exists" },
    { key: "established", icon: Icons.trophy, label: "Established", desc: "Proven market, pricing leverage" },
  ];

  const careerLabel = careerOptions.find(c => c.key === career)?.label || "\u2014";
  const burnFmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(burn);
  const locStr = zip && st ? `${zip}, ${st.toUpperCase()}` : "\u2014";

  return (
    <div style={{
      width: "100%", maxWidth: 393, margin: "0 auto",
      height: "100dvh", maxHeight: 852,
      display: "flex", flexDirection: "column",
      background: C.bg,
      fontFamily: font,
      overflow: "hidden",
      position: "relative",
    }}>
      {/* ─ PROGRESS DOTS ─────────────────────── */}
      <ProgressDots current={step} />

      {/* ─ ILLUSTRATION ──────────────────────── */}
      <div style={{
        flex: "0 0 auto",
        height: "28%",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "0 40px",
        overflow: "hidden",
      }}>
        <div
          key={step}
          style={{
            width: "100%", height: "100%",
            display: "flex", alignItems: "center", justifyContent: "center",
            opacity: transitioning ? 0 : 1,
            transform: transitioning ? `translateX(${slideDir * 30}px)` : "translateX(0)",
            transition: "all 280ms cubic-bezier(0.32, 0.72, 0, 1)",
          }}
        >
          <Illo type={illoKeys[step]} />
        </div>
      </div>

      {/* ─ CONTENT AREA ──────────────────────── */}
      <div style={{
        flex: 1,
        display: "flex", flexDirection: "column",
        overflow: "hidden",
      }}>
        <div
          key={step}
          style={{
            flex: 1,
            padding: "0 24px",
            display: "flex", flexDirection: "column",
            opacity: transitioning ? 0 : 1,
            transform: transitioning ? "translateY(16px)" : "translateY(0)",
            transition: "all 280ms cubic-bezier(0.32, 0.72, 0, 1)",
            overflow: step === 1 ? "auto" : "hidden",
          }}
        >
          {/* ── SCREEN 0: WELCOME ─────────── */}
          {step === 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
                <div style={{
                  width: 28, height: 28, borderRadius: 7,
                  background: C.teal,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <span style={{ color: "#fff", fontWeight: 800, fontSize: 12, fontFamily: font }}>T</span>
                </div>
                <span style={{ fontSize: 14, fontWeight: 600, color: C.inkSoft, fontFamily: font }}>TruePrice</span>
              </div>
              <h1 style={{
                fontSize: 34, fontWeight: 700, color: C.ink,
                lineHeight: 1.08, letterSpacing: "-0.03em",
                margin: 0, fontFamily: font,
              }}>
                Know your floor.<br/>Own your price.
              </h1>
              <p style={{
                fontSize: 15, color: C.inkSoft,
                margin: "14px 0 0", lineHeight: 1.5,
                fontFamily: font,
              }}>
                TruePrice calculates your minimum safe price for each piece — based on your real costs, time, and market context.
              </p>
              <div style={{
                display: "flex", flexDirection: "column", gap: 10,
                marginTop: 24,
              }}>
                {[
                  { icon: Icons.dollar, text: "Your costs set the floor" },
                  { icon: Icons.palette, text: "Market data sets the ceiling" },
                  { icon: Icons.spark, text: "Every piece gets a defensible range" },
                ].map((item, i) => (
                  <div key={i} style={{
                    display: "flex", alignItems: "center", gap: 12,
                  }}>
                    <div style={{
                      width: 32, height: 32, borderRadius: 8,
                      background: C.tealSubtle,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      {item.icon(C.teal)}
                    </div>
                    <span style={{
                      fontSize: 14, color: C.inkMed,
                      fontFamily: font, lineHeight: 1.3,
                    }}>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── SCREEN 1: CAREER STAGE ────── */}
          {step === 1 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <h2 style={styles.title}>Career stage</h2>
                <p style={styles.sub}>This helps contextualize market expectations.</p>
              </div>
              <div style={{
                background: C.card,
                borderRadius: 16,
                border: `1px solid ${C.borderLight}`,
                overflow: "hidden",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
              }}>
                {careerOptions.map((opt, i) => (
                  <SelectionRow
                    key={opt.key}
                    icon={opt.icon}
                    label={opt.label}
                    desc={opt.desc}
                    selected={career === opt.key}
                    onSelect={() => setCareer(opt.key)}
                    isLast={i === careerOptions.length - 1}
                  />
                ))}
              </div>
            </div>
          )}

          {/* ── SCREEN 2: MONTHLY BURN ────── */}
          {step === 2 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1 }}>
              <div>
                <h2 style={styles.title}>Monthly burn</h2>
                <p style={styles.sub}>What it costs you to operate for one month.</p>
              </div>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div style={{ textAlign: "center", marginBottom: 6 }}>
                  <span style={{ fontSize: 11, fontWeight: 600, color: C.inkFaint, textTransform: "uppercase" as const, letterSpacing: "0.06em", fontFamily: font }}>Monthly cost</span>
                </div>
                <ScrollPicker
                  value={burn}
                  onChange={setBurn}
                  min={100}
                  max={15000}
                  step={100}
                  format={(v: number) => `$${v.toLocaleString()}`}
                  visible={5}
                />
              </div>
            </div>
          )}

          {/* ── SCREEN 3: PAINTING HOURS ──── */}
          {step === 3 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1 }}>
              <div>
                <h2 style={styles.title}>Painting hours</h2>
                <p style={styles.sub}>Realistic weekly hours spent painting.</p>
              </div>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div style={{ textAlign: "center", marginBottom: 6 }}>
                  <span style={{ fontSize: 11, fontWeight: 600, color: C.inkFaint, textTransform: "uppercase" as const, letterSpacing: "0.06em", fontFamily: font }}>Hours per week</span>
                </div>
                <ScrollPicker
                  value={hours}
                  onChange={setHours}
                  min={5}
                  max={60}
                  step={1}
                  suffix="hrs"
                  visible={5}
                />
                <p style={{ fontSize: 13, color: C.inkFaint, textAlign: "center", margin: "10px 0 0", fontFamily: font }}>
                  That's about 40 hrs/week full-time.
                </p>
              </div>
            </div>
          )}

          {/* ── SCREEN 4: LOCATION ────────── */}
          {step === 4 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <h2 style={styles.title}>Location</h2>
                <p style={styles.sub}>Used for market context.</p>
              </div>
              <div style={{
                background: C.card,
                borderRadius: 16,
                border: `1px solid ${C.borderLight}`,
                padding: 16,
                display: "flex", flexDirection: "column", gap: 14,
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
              }}>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-end" }}>
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 5 }}>
                    <label style={styles.label}>Zip code</label>
                    <input
                      type="text"
                      value={zip}
                      onChange={handleZipChange}
                      placeholder="90210"
                      maxLength={5}
                      inputMode="numeric"
                      style={styles.input}
                      onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.style.borderColor = C.teal}
                      onBlur={(e: React.FocusEvent<HTMLInputElement>) => e.target.style.borderColor = C.border}
                    />
                  </div>
                  <div style={{ width: 90, display: "flex", flexDirection: "column", gap: 5 }}>
                    <label style={styles.label}>State</label>
                    <div style={{
                      ...styles.input,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      background: st ? C.tealSubtle : C.bg,
                      borderColor: st ? `rgba(61,171,165,0.25)` : C.border,
                      color: st ? C.teal : C.inkGhost,
                      fontWeight: st ? 700 : 400,
                      fontSize: st ? 18 : 15,
                      letterSpacing: st ? "0.05em" : "0",
                      textTransform: "uppercase" as const,
                      cursor: "default",
                      transition: "all 300ms cubic-bezier(0.32, 0.72, 0, 1)",
                    }}>
                      {st || "\u2014"}
                    </div>
                  </div>
                </div>
              </div>
              <button onClick={() => { setZip("90210"); setSt("CA"); }} style={{
                background: "none", border: "none", color: C.teal,
                fontSize: 13, fontWeight: 600, cursor: "pointer",
                padding: "2px 0", textAlign: "left" as const, fontFamily: font,
                display: "flex", alignItems: "center", gap: 6,
              }}>
                {Icons.mapPin(C.teal)} Use my location
              </button>
            </div>
          )}

          {/* ── SCREEN 5: COMPLETE ────────── */}
          {step === 5 && (() => {
            const monthlyHrs = Math.round(hours * 4.33);
            const survRate = monthlyHrs > 0 ? burn / monthlyHrs : 0;
            const survFmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(survRate);
            return (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <h2 style={{ ...styles.title, fontSize: 28 }}>Setup complete.</h2>
              <div style={{
                background: C.card,
                borderRadius: 16,
                border: `1px solid ${C.borderLight}`,
                overflow: "hidden",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
              }}>
                {[
                  { icon: Icons.briefcase, label: "Career stage", val: careerLabel },
                  { icon: Icons.dollar, label: "Monthly burn", val: burnFmt },
                  { icon: Icons.clock, label: "Painting time", val: `${hours} hrs/wk` },
                  { icon: Icons.mapPin, label: "Location", val: locStr },
                ].map((row, i, arr) => (
                  <div key={row.label} style={{
                    display: "flex", alignItems: "center", gap: 14,
                    padding: "14px 16px",
                    borderBottom: i < arr.length - 1 ? `1px solid ${C.borderLight}` : "none",
                  }}>
                    <div style={{
                      width: 32, height: 32, borderRadius: 8,
                      background: C.tealSubtle,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      {row.icon(C.teal)}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, color: C.inkSoft, fontFamily: font }}>{row.label}</div>
                    </div>
                    <div style={{ fontSize: 15, fontWeight: 600, color: C.ink, fontFamily: font, letterSpacing: "-0.01em" }}>
                      {row.val}
                    </div>
                  </div>
                ))}
              </div>
              {/* Survival rate */}
              <div style={{
                background: C.tealSubtle,
                border: `1px solid rgba(61,171,165,0.1)`,
                borderRadius: 14,
                padding: "14px 16px",
                display: "flex", alignItems: "center", gap: 14,
              }}>
                <div style={{ flexShrink: 0, lineHeight: 1 }}>
                  <span style={{
                    fontSize: 26, fontWeight: 700, color: C.teal,
                    fontFamily: font, letterSpacing: "-0.02em",
                  }}>{survFmt}</span>
                  <span style={{ fontSize: 13, fontWeight: 600, color: C.teal }}>/hr</span>
                </div>
                <div style={{
                  fontSize: 12, color: C.inkSoft, lineHeight: 1.4,
                  fontFamily: font,
                }}>
                  Your survival rate. Below this, every hour you paint costs you money.
                </div>
              </div>
              <button onClick={() => go(1)} style={{
                background: "none", border: "none", color: C.teal,
                fontSize: 13, fontWeight: 600, cursor: "pointer",
                padding: "2px 0", textAlign: "center" as const, fontFamily: font,
              }}>
                Edit setup
              </button>
            </div>
            );
          })()}
        </div>

        {/* ─ ACTION BAR (no separator line) ────── */}
        <ActionBar
          showBack={step > 0 && step < 5}
          onBack={back}
          onNext={() => step < 5 ? next() : alert("\u2192 Navigate to Dashboard")}
          nextLabel={ctaText()}
          nextDisabled={!valid()}
        />
      </div>

      {/* ─ STYLES ────────────────────────────── */}
      <style>{`
        * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
        input::placeholder { color: ${C.inkGhost}; }
        button:active { transform: scale(0.97); }
        ::-webkit-scrollbar { display: none; }
        @media (prefers-reduced-motion: reduce) {
          * { transition-duration: 0.01ms !important; }
        }
      `}</style>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  title: {
    fontSize: 26, fontWeight: 700, color: C.ink,
    margin: 0, lineHeight: 1.1,
    letterSpacing: "-0.03em", fontFamily: font,
  },
  sub: {
    fontSize: 14, color: C.inkSoft,
    margin: "5px 0 0", lineHeight: 1.45,
    fontFamily: font,
  },
  label: {
    fontSize: 12, fontWeight: 600, color: C.inkSoft,
    fontFamily: font, letterSpacing: "0.02em",
    textTransform: "uppercase",
  },
  input: {
    height: 48, padding: "0 14px",
    borderRadius: 12,
    border: `1.5px solid ${C.border}`,
    background: C.bg, fontSize: 15,
    color: C.ink, outline: "none",
    fontFamily: font, width: "100%",
    boxSizing: "border-box",
    transition: "border-color 150ms ease",
  },
};
